import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "../../../styles/org-buttons.css";
import "../../../styles/Dataset.css";
import "./CreateModal.css";
import { buttonText } from "../../../utils/buttonText";

function CreateModal({ show, onHide, onCreate, creating }) {
  const [newProjectName, setNewProjectName] = useState("");
  const [newClassName, setNewClassName] = useState("");

  const handleCreate = () => {
    if (!newProjectName) {
      window.alert("Please input project name");
      return;
    }
    onCreate(newProjectName, newClassName, () => {
      setNewProjectName("");
      setNewClassName("");
    });
  };

  const handleClose = () => {
    setNewProjectName("");
    setNewClassName("");
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered className="dataset-enterprise-modal">
      <Modal.Header closeButton closeLabel={buttonText("Close")} className="dataset-modal-header">
        <Modal.Title>Create New Project</Modal.Title>
      </Modal.Header>
      <Modal.Body className="dataset-modal-body">
        <div className="dataset-modal-form">
          <div className="dataset-modal-field">
            <label htmlFor="project-name">Project Name</label>
            <input
              id="project-name"
              type="text"
              className="form-control"
              placeholder="Project Name"
              value={newProjectName}
              onChange={(e) => setNewProjectName(e.target.value)}
              autoFocus
            />
          </div>
          <div className="dataset-modal-field">
            <label htmlFor="class-name">Class Name</label>
            <input
              id="class-name"
              type="text"
              className="form-control"
              placeholder="Class Name"
              value={newClassName}
              onChange={(e) => setNewClassName(e.target.value)}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="org-modal-footer create-modal-footer">
        <div className="create-modal-actions">
          <button type="button" className="org-btn org-btn-secondary" onClick={handleClose}>
            {buttonText("Cancel")}
          </button>
          <button
            type="button"
            className="org-btn org-btn-primary"
            onClick={handleCreate}
            disabled={creating}
          >
            {buttonText(creating ? "Creating..." : "Create")}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateModal;
